// export const type = 'local'
// export const type = 'dev'
export const type = 'live'



// WEBPACK FOOTER //
// ./src/env.js